(function () {
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lazyVideos = Array.prototype.slice.call(document.querySelectorAll('video[data-adflex-lazy-video]'));

  function hydrate(video) {
    if (video.getAttribute('data-adflex-hydrated') === 'true') return;

    Array.prototype.slice.call(video.querySelectorAll('source[data-src]')).forEach(function (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
    });

    video.setAttribute('data-adflex-hydrated', 'true');
    video.load();
  }

  function play(video) {
    hydrate(video);
    if (reducedMotion) return;
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(function () {});
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          play(video);
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '240px 0px', threshold: 0.08 });

    lazyVideos.forEach(function (video) {
      observer.observe(video);
    });
  } else {
    lazyVideos.forEach(play);
  }

  if (reducedMotion) {
    Array.prototype.slice.call(document.querySelectorAll('video[autoplay]')).forEach(function (video) {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      Array.prototype.slice.call(document.querySelectorAll('video')).forEach(function (video) {
        video.pause();
      });
    }
  });

  function correctPrivacyLink() {
    var privacyLink = document.querySelector('#shopify-pc__banner__body-policy-link');
    if (!privacyLink) return false;
    privacyLink.href = '/pages/privacy-policy';
    return true;
  }

  if (!correctPrivacyLink() && 'MutationObserver' in window) {
    var privacyObserver = new MutationObserver(function () {
      if (correctPrivacyLink()) privacyObserver.disconnect();
    });
    privacyObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      privacyObserver.disconnect();
    }, 10000);
  }
})();
